import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { RegPatService } from '../reg-pat-service/reg-pat-service'
import { PriSupplierServicesStp } from '../pricing-interface/supplier-services-interface';
import { CONFIG } from '../../shared/config';
import { ServiceCoditions } from '../service-conditions/service-conditions';

let servicesSettingUrl = CONFIG.baseUrls.servicesSetting;
let ServiceCompositeDetailUrl = CONFIG.baseUrls.serviceCompositeDetail;

export interface ServiceSetting {
    serviceCode: number;
    customServiceCode: string;
    nameAr: string;
    nameEn: string;
    valid: number;
    parentCode: number;
    costCenter: number;
    costCenterLevel: number;
    creditAccountCode: number;
    accountCode: number;
    serviceType: number;
    nphiesTerminology: number;
    cptCode: number;
    bill_Item: number;
    levelNo: number;
    acceptFees: boolean;
    
  submissivetoLoyaltyPoints:number,
    // bodyPartFlag: boolean;
    serviceCost: number;
    repeatCheck: number;
    repeatPeriod: number;
    repeatAction: number;
    cCHICODE: number
    operSkill: number;
    dealFlag?: number;
    leadsFlag?: number;
    maxDiscountValue?: number;
    //extended property
    serviceTypeEn: string;
    serviceTypeAr: string;
    costCenterNameEn: string;
    costCenterNameAr: string;
    accountNameEn: string;
    accountNameAr: string;
    repeatActionAr: string;
    repeatActionEn: string;
    execuetedOutSideHosp?: number;
    hasHtmlReport?: number
    hasVadFlag?: number;
    vadType?: number;
    vadValue?: number;
    composite?: number
    loyaltyPoints?: number;
    genRadModalityType?: number;
    collapse?: boolean;
    hasMultiSession?: number;
    necessaryDisbursementRequired?: number;
    nesessoryInsertPartsOfbody?: number;
    variablePriceFlag?: number;
    variablePriceMaxLimit?: number;
    multiPrintFlag?: number
    branchCodeArr?: string
    bodyPartSelectionOption?: number;
    prepaidservice?: number;
    claimedPerCapita: number;
    portalDescriptionAr: string;
    portalDescriptionEn: string;
    imgName: string;
    gs1: string;
    egs: string;
    gpc: string;
    portalSpeciality: number;
    portalVisibility: number;
    hasImage: number;
    completionServiceTolerancePeriod?: number;
    isCompletionService?: number;
    availableOnWebsite?: number;
    availableOnMobile?: number;
    availableOnTelemedicine?: number;
    surgicalInterventionsService?: number;
    defaultDiagnosis?: number;
 
}
export interface PriServiceCompositeDetail {
    serial?: number,
    compositeServiceCode?: number,
    simpleServiceCode?: number,
    simpleServiceNameAr?: number
    compositeServiceNameAr?: number
    itemCount?: number;
}
export interface ServiceCompositeDetail {
    serviceCompositeDetailArray: PriServiceCompositeDetail[]
}

@Injectable()
export class ServiceSettingService {
    parentId: number;
    levelNum: number;
    constructor(
        private _HttpGeneralService: HttpGeneralService) { }

    getServicesSetting(parentId: number, type: number, valid: number) {
        return this._HttpGeneralService.getWith(`${servicesSettingUrl}/parent/${parentId}/${type}/${valid}`);
    }

    addServiceSetting(serviceSetting: ServiceSetting) {
        return this._HttpGeneralService.add(serviceSetting, `${servicesSettingUrl}`);

    }

    searchServicesSetting(k?: string) {
        let keyword = k || " ";
        return this._HttpGeneralService.getWith(`${servicesSettingUrl}/search/${keyword}`);
    }




    searchServicesSettingObj(serviceSettingKey: ServiceSetting) {
        return this._HttpGeneralService.add(serviceSettingKey, `${servicesSettingUrl}/search`);
    }

    getServiceSetting(id: number) {
        return this._HttpGeneralService.getWith(`${servicesSettingUrl}/${id}`);
    }



    updateServiceSetting(serviceSetting: ServiceSetting) {
        return this._HttpGeneralService.update(serviceSetting.serviceCode, serviceSetting, `${servicesSettingUrl}`);
    }

    deleteServiceSetting(serviceSetting: ServiceSetting) {
        return this._HttpGeneralService.delete(serviceSetting.serviceCode, `${servicesSettingUrl}`);
    }

    // get service cost
    getServiceCost(regPatService: RegPatService[]) {
        return this._HttpGeneralService.add(regPatService, `${servicesSettingUrl}/serviceCost`);
    }

    //#region service condition

    serviceConditionSearch(condition) {
        return this._HttpGeneralService.search(condition, `${servicesSettingUrl}/Conditions`);
    }
    // RegPatServConditionRes
    addRegPatServConditionRes(RegPatServConditionRes: ServiceCoditions[]) {
        return this._HttpGeneralService.add(RegPatServConditionRes, `${servicesSettingUrl}/RegPatServConditionRes`);
    }
    //#endregion

    serviceConditionAddCollection(condition) {
        return this._HttpGeneralService.addCollection(condition, `${servicesSettingUrl}/Conditions`);
    }

    //#region service Supplier setup
    getServiceSupplier(serviceSupplier: PriSupplierServicesStp) {
        return this._HttpGeneralService.search(serviceSupplier, `${servicesSettingUrl}/SupplierServices`);
    }

    addServiceSuppliers(serviceSupplier: PriSupplierServicesStp[]) {
        return this._HttpGeneralService.addCollection(serviceSupplier, `${servicesSettingUrl}/SupplierServices/collection`);
    }
    //#endregion
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    getServiceCompositeDetail(id: number) {
        return this._HttpGeneralService.get(id, ServiceCompositeDetailUrl);
    }

    addServiceCompositeDetail(ServiceCompositeDetail: ServiceCompositeDetail) {
        return this._HttpGeneralService.add(ServiceCompositeDetail, ServiceCompositeDetailUrl);
    }

    deleteServiceCompositeDetail(ServiceCompositeDetail: PriServiceCompositeDetail) {
        return this._HttpGeneralService.delete<number>(ServiceCompositeDetail.serial, ServiceCompositeDetailUrl);
    }

}
